import { ApiHandlerDiscreteParameter, HasOnSuccess, replaceInChain } from "@insite/client-framework/HandlerCreator";
import {
    FulfillmentMethod,
    getSession,
    Session,
    updateSession,
    UpdateSessionApiParameter,
} from "@insite/client-framework/Services/SessionService";
import { chain, PopulateApiParameter } from "@insite/client-framework/Store/Context/Handlers/UpdatePickUpWarehouse";

import loadCurrentCart from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCurrentCart";
import { WarehouseModel } from "@insite/client-framework/Types/ApiModels";

type UpdatePickUpWarehouseParameter = {
    pickUpWarehouse: WarehouseModel;
} & HasOnSuccess;

type HandlerType = ApiHandlerDiscreteParameter<UpdatePickUpWarehouseParameter, UpdateSessionApiParameter, Session>;

export const PopulateApiParameterUpdated: HandlerType = props => {
    const isPickUp = props.getState().context.session.fulfillmentMethod === FulfillmentMethod.PickUp;
 if(isPickUp){
     props.apiParameter = {
         session: {
             pickUpWarehouse: { id: props.parameter.pickUpWarehouse.id } as WarehouseModel,
             customerWasUpdated: false,
         } as Session,
     };
 }else{
     props.apiParameter = {
         session: {
             pickUpWarehouse: { id: props.parameter.pickUpWarehouse.id } as WarehouseModel,
             customerWasUpdated: false,
             fulfillmentMethod: "Ship",
         } as Session,
     };
 }
    
 };

replaceInChain(chain, PopulateApiParameter, PopulateApiParameterUpdated);
